export const generateRandomNumber = () => Math.floor(Math.random() * 5);